/**
 * 🧱 Refactor BT Phase 3 — Étape 3 : `putBon` unique pour BonTravailDetail.jsx.
 *
 * Remplace les 4 `axios.put(`${API_URL}/api/crm/bons-travail/${bon.id}`, stripMaskedHeuresBudgeteesFields({ ...bon, <modifs> }), config?)`
 * (ajout / retrait rapide d'employé, fin d'utilisation d'équipement, commande de produits).
 * Corps envoyé STRICTEMENT identique : `stripMaskedHeuresBudgeteesFields({ ...bon, ...modifs })` (strip Règle 2 / v13.62
 * inchangé — goldens `detail_01..04`). `config` (ex. en-tête Authorization explicite de 2 appels d'origine) est
 * transmis tel quel à axios pour ne rien changer au comportement réseau.
 */
import axios from 'axios';
import { API_URL } from '../components/crm/bon-travail/utils';  // relatif : Jest n'a pas l'alias '@/'
import { stripMaskedHeuresBudgeteesFields } from '../components/crm/bon-travail/btSavePayloadHelpers';

export function construirePayloadDetail(bon, modifs) {
  return stripMaskedHeuresBudgeteesFields({ ...bon, ...modifs });
}

export function useBtDetailActions(bon) {
  const putBon = (modifs, config) =>
    axios.put(`${API_URL}/api/crm/bons-travail/${bon.id}`, construirePayloadDetail(bon, modifs), config);
  return { putBon };
}
